import './Test.scss';

export default function Test() {
  return (
    <div className="testbox">
      <p>{navigator.userAgent}</p>
    </div>
  );
}
